var map = {
	"./cctv-default.png": "39eb",
	"./cctv-emergency.png": "77a0",
	"./cctv-handSanitizerDetector.png": "74c5",
	"./cctv-iisi-disable.png": "cb65",
	"./cctv-iisi.png": "e13b",
	"./cctv-odor.png": "576e",
	"./cctv-traffic-disable.png": "2872",
	"./cctv-traffic.png": "77d0",
	"./cctv-weather.png": "ffea",
	"./cctv-weather1.png": "fc99"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb61";